<template>
  <v-container fluid class="route-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/route/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="routes-table"
              show-select
              single-select
              item-key="_id"
              sort-by="routenum"
              :headers="header_items"
              :items="routes"
              :items-per-page="itemPerPage"
              :footer-props="footer"
              >
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteRoute"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Route?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_route.routename }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteRoute = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteRoute(delete_route)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.locationid="{ item }">
                {{ locations.length>0 && locations.find(i=>i._id==item.locationid)!=null ? locations.find(i=>i._id==item.locationid)['locationname'] : '' }}
              </template>
              <template v-slot:item.repid="{ item }">
                <div v-if="item.repid!=undefined">
                  <p class="two-line" style="margin-left: 0px;">
                    <v-avatar v-if="item.repid!=null && users.length>0" size="40">
                      <img v-bind:src="users.find(i=>i._id == item.repid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <p class="two-line"><span class="white--text headline">{{ item.repid!=null && users.length>0 ? users.find(user=>i._id==item.repid)['username'][0].toUpperCase() : '' }}</span></p>
                    </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:0px; font-size: 9pt;">{{ item.repid!=null && users.length>0 ? users.find(i=>i._id==item.repid)['username'] : '' }} </span></p>
                </div>
              </template>
              <template v-slot:item.routestatus="{ item }">
                <v-chip
                  :color="!item.routestatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.routestatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editRoute(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteRouteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'RouteList',
  data() {
    return {
      isDeleteRoute: false,
      delete_route: {},
      item_seleted: [],
      header_items: [
        { text: '#', value: 'routenum', width: '5px'},
        { text: 'Sales Rep', value: 'repid', width: '15%'},
        { text: 'Name', value: 'routename'},
        { text: 'Location', value: 'locationid', width: '15%'},
        { text: 'Create', value: 'createdAt', width: '15%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '12%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  computed: {
    ...mapState('Location', ['locations']),
    ...mapState('Route', ['routes', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('Route', ["deleteRouteRequest","getRoutesRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    editRoute(item) {
      this.$router.push({name: 'RouteEdit', params: item});
    },
    deleteRoute(item) {
      this.deleteRouteRequest(item);
      this.isDeleteRoute = false;
    },
    deleteRouteDialog(item) {
      this.isDeleteRoute = true;
      this.delete_route = {_id: item._id,routename: item.routename};
    },
  },
  async created () {
    if(this.routes.length==0) await this.getRoutesRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
